export class CreateTransactionItemModel {
  PatientId: string;
  PatientCaseId: string;
  CaseProcedureId: string;
  Code: string;
  CodeDescription: string;
  LOCID: number;
  ToothID: string;
  CaseWorkItemID: string;
  CaseWorkItemToothId: string;
  InsuranceID: string;
  ProviderDoctorID: string;
  FeeScheduleID: string;
  TransactionDate: Date;
  PatientInsuranceID: string;
  DocFeeScheduleID: string;
  FeeScheduleItemID: string;
  enumFeeItemCategoryId: string;
  WorkItemEventId: string;
  ItemOrder: number;

  DiscountID: string;
  DiscountPCT: number;
  DiscountAmount: number;
  enumFeeDiscountCalcTypeId: string;
}
